import { create } from "zustand";

type DeviceInfo = {
    deviceId: string;
    pushToken: string;
};

type DeviceInfoState = {
    deviceInfo: DeviceInfo;
    setDeviceInfo: (info: Partial<DeviceInfo>) => void;
    reset: () => void;
};

export const useDeviceInfoStore = create<DeviceInfoState>((set, get) => ({
    deviceInfo: { deviceId: "", pushToken: "" },
    setDeviceInfo: (info) => set({ deviceInfo: { ...get().deviceInfo, ...info } }),
    reset: () => set({ deviceInfo: { deviceId: "", pushToken: "" } }),
}));
